






import {  Vue } from "vue-property-decorator";

export default class App extends Vue {
  // private userId = '';
  // private designId = '';
  // computeLayout=''

  mounted(): void {
    // window.addEventListener("message", this.onmessage);
    // this.getUserId()
    // window.parent.postMessage({action: "getUserId"}, "*");
  }
  beforeDestroy(): void {
    // window.removeEventListener("message", this.onmessage);
  }
  // onmessage(event: MessageEvent) {
  //   console.log(event,'event');
  //   if (event.data.action === "userId") {
  //     sessionStorage.setItem('userId',event.data.value);
  //     console.log(event.data.action,'userIdApp');
  //   } else if (event.data.action === "designId") {
  //     sessionStorage.setItem('designId',event.data.value)
  //   }
  // }
  //
  // getUserId() {
  //   console.log(123);
  //   window.parent.postMessage({action: "getUserId"}, "*");
  // }
  //
  // private getDesignId() {
  //   window.parent.postMessage({ action: "getDesignId" }, "*");
  // }
  // getComputeLayout(){
  //   window.parent.postMessage({ action: "computeLayout" }, "*");
  // }
}
